import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
} from "@mui/material";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import { Link } from "react-router-dom";

interface Travel {
  airline: string;
  airline_code: string;
  booking_txn_id: string;
  cabin_class: string;
  departure_date: string;
  flight_number: string;
  passenger_name: string;
  passenger_type: string;
  route: string;
}

interface UpcomingTravelProps {
  data: Travel[];
  height: any;
}

const UpcomingTravel = ({ data, height }: UpcomingTravelProps) => {
  const hasData = data && data.length > 0;

  return (
    <div className="border-0 shadow-sm card h-full">
      <div className="card-header dashboard-card-header">
        <h6 className="mb-0 fw-semibold">Upcoming Travels</h6>
        <button
          type="button"
          className="text-decoration-none btn btn-link btn-sm veiw-all-btn"
        >
          <Link to="/flightbookinghistory?tab=1">
            View All <ArrowOutwardOutlinedIcon sx={{ fontSize: 16 }} />
          </Link>
        </button>
      </div>

      <CardContent sx={{ p: 0 }} className={height}>
        {hasData ? (
          <List>
            {data.map((item, index) => (
              <>
                <ListItem
                  key={index}
                  secondaryAction={
                    <Typography variant="caption" color="text.secondary">
                      {item.departure_date}
                      {/* date + time */}
                    </Typography>
                  }
                >
                  <ListItemAvatar>
                    <Avatar sx={{ fontSize: "10px" }}>{item.airline}</Avatar>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <Typography variant="subtitle2">
                        {item.airline}
                      </Typography>
                    }
                    secondary={item.route}
                  />
                </ListItem>
              </>
            ))}
          </List>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <Typography variant="body2" align="center">
              No upcoming travels
            </Typography>
          </Box>
        )}
      </CardContent>
    </div>
  );
};

export default UpcomingTravel;
